export function hasOwnProperty<T>(obj: T, property: string): boolean {
  return Object.prototype.hasOwnProperty.call(obj, property);
}
